/**
 * Google Ads conversions of the setup flow (§4.13, D28), and the rule of its
 * one-shot GA event. Components pass `vueData.conversion.bind(vueData)` as
 * the sender; nothing here can throw.
 */

export const ADS_ACCOUNT_ID = '1036472587';

export interface IAdsConversion {
  label: string;
  name: string;
}

export type TAdsConversionSender = (
  accountId: string,
  label: string,
  name: string
) => void;

/** Fired on every store creation, exactly as the legacy modal did. */
export const CREATE_STORE_CONVERSION: IAdsConversion = {
  label: '6XdgCKOUgdgBEIuine4D',
  name: 'Crear tienda',
};

/**
 * Label of the «Menú publicado» conversion, supplied by the owner
 * (prerequisite P3). Empty until then: `fireAdsConversion` skips it.
 */
export const MENU_PUBLISHED_CONVERSION_LABEL = '';

/** Fired once per flow store, on its first publish (`firstMenuPublish`). */
export const MENU_PUBLISHED_CONVERSION: IAdsConversion = {
  label: MENU_PUBLISHED_CONVERSION_LABEL,
  name: 'Menú publicado',
};

/** The legacy «5 dishes» conversion (`RestaurantItems.vue`), also fired by a first publish with ≥5 visible dishes. */
export const FIVE_ITEMS_CONVERSION: IAdsConversion = {
  label: 'E_r3CNWk8tcBEIuine4D',
  name: 'Añadir 5 items al menú',
};

/** Visible dishes a first publish needs to fire `FIVE_ITEMS_CONVERSION`. */
export const FIVE_ITEMS_THRESHOLD = 5;

/**
 * GA `menu_path_chosen` (§4.13) reports the first way in only. Every way in
 * that stays on the menu step (photos, a file, text, a copy, «Cargarlo a
 * mano») creates the store's import session, so once the session exists its
 * first path was reported: a reload, the source screen after a failed read or
 * «Cargar otra vez» report nothing. `reported` covers a second action of the
 * same screen before the session exists.
 */
export function isFirstMenuPath(state: {
  sessionId: string | null;
  reported: boolean;
}): boolean {
  return !state.reported && state.sessionId === null;
}

/** Sends one conversion; an empty label is a no-op and a failing sender is swallowed. */
export function fireAdsConversion(
  conversion: IAdsConversion,
  send: TAdsConversionSender
): void {
  if (!conversion.label) return;
  try {
    send(ADS_ACCOUNT_ID, conversion.label, conversion.name);
  } catch (error) {
    console.error('[store-setup] Ads conversion failed', error);
  }
}
